// Tiny field diagram with one zone highlighted. Drawn at runtime from the
// zone geometry (no image assets). Same rectangles as engine game/zones.hh
// (relative to your own goal, drawn portrait with own goal at the BOTTOM).
// Reused later as the seed of the Z4 visual zone picker (just larger).

const W = 100, H = 200; // field: width x length (matches the engine)

// z (0..11) -> {x0,x1,y0,y1} in field coords. Keep in sync with zones.hh.
const ZONE_RECTS = [
  { x0: 21, x1: 79, y0:   0, y1:  32 }, // 0 MY_BOX          (official depth 32)
  { x0: 21, x1: 79, y0:  32, y1: 100 }, // 1 MY_CENTRE
  { x0: 21, x1: 79, y0: 100, y1: 168 }, // 2 OPPONENT_CENTRE
  { x0: 21, x1: 79, y0: 168, y1: 200 }, // 3 OPPONENT_BOX
  { x0:  0, x1: 21, y0:   0, y1:  67 }, // 4 LEFT_WING_DEF
  { x0:  0, x1: 21, y0:  67, y1: 133 }, // 5 LEFT_WING_MID
  { x0:  0, x1: 21, y0: 133, y1: 200 }, // 6 LEFT_WING_ATT
  { x0: 79, x1:100, y0:   0, y1:  67 }, // 7 RIGHT_WING_DEF
  { x0: 79, x1:100, y0:  67, y1: 133 }, // 8 RIGHT_WING_MID
  { x0: 79, x1:100, y0: 133, y1: 200 }, // 9 RIGHT_WING_ATT
  { x0:  0, x1:100, y0:   0, y1: 100 }, // 10 MY_HALF
  { x0:  0, x1:100, y0: 100, y1: 200 }, // 11 OPPONENT_HALF
];

const ARGUMENT_OFFSET = 2000;

/** value = the stream int of a zone (2000 + z). size = height in px. */
export function ZoneThumbnail({ value, size = 24 }) {
  const R = ZONE_RECTS[value - ARGUMENT_OFFSET];
  if (!R) return null;

  const toY = (y) => H - y; // field y grows up; SVG y grows down

  return (
    <svg
      className="zone-thumb"
      width={size * (W / H)}
      height={size}
      viewBox={`0 0 ${W} ${H}`}
      aria-hidden="true"
    >
      <rect x="1" y="1" width={W - 2} height={H - 2} fill="#1f7a3a" stroke="#fff" strokeWidth="2" />
      <line x1="0" y1={H / 2} x2={W} y2={H / 2} stroke="#fff" strokeWidth="1.5" opacity="0.45" />
      <rect
        x={R.x0}
        y={toY(R.y1)}
        width={R.x1 - R.x0}
        height={R.y1 - R.y0}
        fill="#ffd54a"
        opacity="0.8"
      />
    </svg>
  );
}
